import React from 'react';

const StairsLoader = () => {
  return (
    <div className="stairs-loader">
      <div className="stairs-loader__bar"></div>
      <div className="stairs-loader__bar"></div>
      <div className="stairs-loader__bar"></div>
      <div className="stairs-loader__bar"></div>
      <div className="stairs-loader__bar"></div>
      <div className="stairs-loader__ball"></div>
    </div>
  );
};

export default StairsLoader;
